import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import classnames from 'classnames';

export default class CountdownTimer extends Component {
  componentDidMount() {
    this.timer = setInterval(() => this.forceUpdate(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const { title, datetime, background } = this.props;

    const totalSeconds = moment(datetime).diff(moment(), "seconds");
    let seconds = totalSeconds, multiplier;

    multiplier = 24 * 60 * 60;
    const days = Math.floor(seconds / multiplier);
    seconds -= days * multiplier;

    multiplier = 60 * 60;
    const hours = Math.floor(seconds / multiplier);
    seconds -= hours * multiplier;

    multiplier = 60;
    const minutes = Math.floor(seconds / multiplier);
    seconds -= minutes * multiplier;

    const formatNumber = n => {
      if (totalSeconds < 0) {
        return "00";
      }

      return n <= 9? `0${n}` : n;
    }

    return (
      <section className={classnames("block block-countdown-timer", background)}>
        <div className="row columns small-16">
          <h3>{ title }</h3>
          <div className="timer-box">
            <div className="item">
              <div className="value">{ formatNumber(days) }</div>
              <div className="label">Days</div>
            </div>
            <div className="separator">:</div>
            <div className="item">
              <div className="value">{ formatNumber(hours) }</div>
              <div className="label">Hours</div>
            </div>
            <div className="separator">:</div>
            <div className="item">
              <div className="value">{ formatNumber(minutes) }</div>
              <div className="label">Minutes</div>
            </div>
            <div className="separator">:</div>
            <div className="item">
              <div className="value">{ formatNumber(seconds) }</div>
              <div className="label">Seconds</div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

CountdownTimer.propTypes = {
  title: PropTypes.string.isRequired,
  datetime: PropTypes.string.isRequired,
  background: PropTypes.string,
};
